'use client'

// App-level Twetch UI switches. The profile editor is ONE dialog, opened from
// anywhere a person sees their own face — the composer, their profile, a menu
// — so every door leads to the same form instead of each surface growing its
// own copy.

import { create } from 'zustand'

interface TwetchUi {
	profileEditorOpen: boolean
	openProfileEditor: () => void
	closeProfileEditor: () => void
}

export const useTwetchUi = create<TwetchUi>((set) => ({
	profileEditorOpen: false,
	openProfileEditor: () => set({ profileEditorOpen: true }),
	closeProfileEditor: () => set({ profileEditorOpen: false })
}))

/// Callable outside React (menus, command handlers).
export function openProfileEditor(): void {
	useTwetchUi.getState().openProfileEditor()
}
